module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<select ")
    ; __append( Html.attributes(locals.attributes) )
    ; __append(" >\n    ")
    ;  if (locals.showEmpty) { 
    ; __append("\n    <option value=\"\"></option>\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (locals.prepend) { 
    ; __append("\n    ")
    ;  Util.each(locals.prepend, function (item) { 
    ; __append("\n    <option\n        value=\"")
    ; __append(escapeFn( item.value ))
    ; __append("\"\n        ")
    ; __append( Html.selected(locals.selected === item.value) )
    ; __append("\n    >\n        ")
    ; __append(escapeFn( item.title ))
    ; __append("\n    </option>\n    ")
    ;  }); 
    ; __append("\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (locals.items) { 
    ; __append("\n    ")
    ;  Util.each(locals.items, function (label, value) { 
    ; __append("\n    ")
    ;  if (!locals.filter || ~locals.filter.indexOf(value)) { 
    ; __append("\n    <option\n        value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n        ")
    ; __append( Html.selected(locals.selected === value) )
    ; __append("\n    >\n        ")
    ; __append(escapeFn( label ))
    ; __append("\n    </option>\n    ")
    ;  } 
    ; __append("\n    ")
    ;  }); 
    ; __append("\n    ")
    ;  } 
    ; __append("\n</select>\n")
  }
  return __output.join("");

}